export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"property":"theme-color","content":"#ffffff"},{"property":"msapplication-TileColor","content":"#e2f5ff"},{"name":"apple-mobile-web-app-title","content":"Careum"},{"property":"og:title","content":"Careum"},{"property":"og:site_name","content":"Careum"},{"property":"fb:app_id","content":"966242223397117"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"mask-icon","href":"/safari-pinned-tab.svg","color":"#18246f"}],"style":[],"script":[{"innerHTML":"\n            // Define dataLayer and the gtag function.\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            // Default ad_storage to 'denied' as a placeholder\n            gtag('consent', 'default', {\n              ad_storage: 'denied',\n              analytics_storage: 'denied',\n              functionality_storage: 'denied',\n              personalization_storage: 'denied',\n              security_storage: 'granted',\n              ad_user_data: 'denied',\n              ad_personalization: 'denied',\n              wait_for_update: 2000\n            });\n            gtag('set', 'ads_data_redaction', true);\n            gtag('set', 'url_passthrough', true);\n          ","type":"text/javascript"},{"src":"https://cdn-cookieyes.com/client_data/70b1d7414ee6051d9f18f56a9a7136d5/script.js","type":"text/javascript"}],"noscript":[],"title":"Careum"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true